<template>
  <div class="reporte_compras">
    <hr>
    <h5>Reporte Compras Por Proveedor</h5>
    <br>
    <form @submit.prevent="filtrar()">
      <div class="form-group">
        <div class="input-group mr-1">
          <label for="desde">Desde</label>
          <input required type="datetime-local" id="desde" v-model="desde">
          <i class="bar"></i>
        </div>
        <div class="input-group mr-1">
          <label for="hasta">Hasta</label>
          <input type="datetime-local" id="hasta" v-model="hasta">
          <i class="bar"></i>
        </div>
        <div class="input-group">
          <label for="sucursal">Sucursal</label>
          <select required name="sucursal" id="sucursal" v-model="sucursal">
            <option value="">Seleccione...</option>
            <option v-for="item in $store.getters.sucursales" :value="item.nombre">{{item.nombre}}</option>
          </select>
          <i class="bar"></i>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <button class="btn btn-micro btn-warning" type="submit">Filtrar</button>
        </div>
      </div>
    </form>

    <div id="iframe"></div>
  </div>
</template>

<script>
  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import moment from "moment";

  export default {
    name: "reporteCompras",
    components: {VuesticWidget},
    data() {
      return {
        desde: '',
        hasta: '',
        codigo: '',
        sucursal: '',
      }
    },
    methods: {
      filtrar() {
        const desde = moment(this.desde).unix() + '000'
        const hasta = moment(this.hasta).unix() + '000'
        const url = `http://54.233.200.30:3001/d/lbJij6tGz/reporte-compras-por-proveedor?orgId=1&from=${desde}&to=${isNaN(parseInt(hasta)) ? 'now' : hasta}&var-sucursal=${this.sucursal || "All"}"`
        const frame = document.getElementById('iframe')
        frame.innerHTML = `<iframe
        src="${url}"
        height="500" width="100%"></iframe>`
        console.log(url, 'URL')
      }
    }
  }
</script>

<style scoped>

</style>
